module.exports = __webpack_public_path__ + "static/media/msp_03.afac1d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_03.png
// module id = 92
// module chunks = 5 6 7 8 9 10 11 13 14